import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    refresh: false,
    alertB: false,
    alertG: false,
    alertM: "",

    modal_add: false,
    modal_edit: false,
    modal_detail: false,
    modal_delete: false,

    data: {},
  },

  mutations: {
    refresh(state, payload) {
      state.refresh = payload;
    },

    alert_text(state, payload) {
      state.alertM = payload;
    },

    alert_b(state, payload) {
      state.alertB = payload;
    },

    alert_g(state, payload) {
      state.alertG = payload;
    },

    // MODAL ADD
    open_add(state, payload) {
      state.modal_add = payload.value;
      state.data = payload.item;
    },

    close_add(state, payload) {
      state.modal_add = payload;
      state.data = {};
    },

    // MODAL EDIT
    open_edit(state, payload) {
      state.modal_edit = payload.value;
      state.data = payload.item;
    },

    close_edit(state, payload) {
      state.modal_edit = payload;
      state.data = {};
    },

    // MODAL DELETE
    open_delete(state, payload) {
      state.modal_delete = payload.value;
      state.data = payload.item;
    },

    close_delete(state, payload) {
      state.modal_delete = payload;
      state.data = {};
    },

    // MODAL DETAIL
    open_detail(state, payload) {
      state.modal_detail = payload.value;
      state.data = payload.item;
    },

    close_detail(state, payload) {
      state.modal_detail = payload;
      state.data = {};
    },
  },
});
